import Main from '@/views/main.vue'

import { registerListMenuRouter } from './list'

const registerMenuRouter = {
  has: 'storeRegister',
  path: '/',
  icon: 'android-people',
  name: 'registerMenuRouter',
  title: '到店登记',
  component: Main,
  children: [
    ...registerListMenuRouter
  ]
}

export { registerMenuRouter }



// WEBPACK FOOTER //
// ./src/router/register/index.js